export default function communityCentroidForce() {
  let nodes;

  function force() {
    if (!nodes) return;
    const accum = new Map();
    for (const n of nodes) {
      if (n.virtual) continue;
      const vn = n.virtualNode;
      if (!vn) continue;
      if (!accum.has(vn)) accum.set(vn, { x: 0, y: 0, w: 0 });
      const w = n.radius || 1;
      const a = accum.get(vn);
      a.x += (n.x || 0) * w;
      a.y += (n.y || 0) * w;
      a.w += w;
    }
    for (const [vn, a] of accum) {
      if (!a.w) continue;
      const x = a.x / a.w;
      const y = a.y / a.w;
      vn.x = x;
      vn.y = y;
      vn.vx = 0;
      vn.vy = 0;
      vn.mass = a.w;
    }
  }

  force.initialize = function (_) {
    nodes = _;
  };

  return force;
}
